'use client'

import React from 'react'
import { cn } from '@/lib/utils'
import { HybridTooltip, HybridTooltipTrigger, HybridTooltipContent } from './ui/hybrid-tooltip'

//https://github.com/shadcn-ui/ui/issues/86#issuecomment-2241817826
export const Tip = ({
  content,
  children,
}: React.PropsWithChildren<{ content: string | React.ReactNode; className?: string }>) => {
  return (
    <HybridTooltip delayDuration={150}>
      <HybridTooltipTrigger asChild>
        <span className={'cursor-pointer inline-block'}>{children}</span>
      </HybridTooltipTrigger>
      <HybridTooltipContent
        side="top"
        className={cn(
          'wrap-break-word text-sm max-w-xs p-3',
          'bg-foreground text-background border-foreground/20',
        )}
      >
        {content}
      </HybridTooltipContent>
    </HybridTooltip>
  )
}
